(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-rotator')) {
    customElements.define(
      'announcement-rotator',
      class AnnouncementRotator extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('.announcement__slide'));
          if (this.slides.length < 2) return;

          // Honour reduced motion by simply not cycling.
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          this.index = 0;
          const interval = Number(this.dataset.interval) || 5000;
          this.timer = setInterval(() => this.next(), interval);

          this.addEventListener('mouseenter', () => clearInterval(this.timer));
          this.addEventListener('mouseleave', () => {
            this.timer = setInterval(() => this.next(), interval);
          });
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        next() {
          this.slides[this.index].classList.remove('is-active');
          this.index = (this.index + 1) % this.slides.length;
          this.slides[this.index].classList.add('is-active');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('compare-slider')) {
    class CompareSlider extends HTMLElement {
      connectedCallback() {
        this.frame = this.querySelector('.compare-slider__frame');
        this.handle = this.querySelector('[data-compare-handle]');
        if (!this.frame || !this.handle) return;

        this.value = parseFloat(this.dataset.start) || 50;
        this.dragging = false;

        this.onPointerDown = (event) => {
          this.dragging = true;
          if (this.frame.setPointerCapture) {
            try {
              this.frame.setPointerCapture(event.pointerId);
            } catch (error) {
              /* Pointer capture is best-effort. */
            }
          }
          this.setFromClientX(event.clientX);
        };
        this.onPointerMove = (event) => {
          if (!this.dragging) return;
          this.setFromClientX(event.clientX);
        };
        this.onPointerUp = () => {
          this.dragging = false;
        };

        this.frame.addEventListener('pointerdown', this.onPointerDown);
        this.frame.addEventListener('pointermove', this.onPointerMove);
        this.frame.addEventListener('pointerup', this.onPointerUp);
        this.frame.addEventListener('pointercancel', this.onPointerUp);

        this.handle.addEventListener('keydown', (event) => {
          const step = event.shiftKey ? 10 : 4;
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.setValue(this.value - step);
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.setValue(this.value + step);
          } else if (event.key === 'Home') {
            event.preventDefault();
            this.setValue(0);
          } else if (event.key === 'End') {
            event.preventDefault();
            this.setValue(100);
          }
        });

        this.setValue(this.value);
      }

      setFromClientX(clientX) {
        const rect = this.frame.getBoundingClientRect();
        if (!rect.width) return;
        const percent = ((clientX - rect.left) / rect.width) * 100;
        this.setValue(percent);
      }

      setValue(percent) {
        this.value = Math.min(100, Math.max(0, percent));
        this.style.setProperty('--start', this.value + '%');
        this.handle.setAttribute('aria-valuenow', String(Math.round(this.value)));
      }
    }
    customElements.define('compare-slider', CompareSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    const escapeHtml = (value) =>
      String(value).replace(/[&<>"']/g, (char) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      })[char]);

    class BundleBuilder extends HTMLElement {
      connectedCallback() {
        this.maxSlots = Number(this.dataset.maxSlots) || 1;
        this.tierMode = this.dataset.tierMode || 'percent';
        this.unitNoun = this.dataset.unitNoun || 'item';
        this.savingsDisplay = this.dataset.savingsDisplay || 'percent';
        this.showFreeShipping = this.dataset.showFreeShipping === 'true';
        this.freeShippingThreshold = Number(this.dataset.freeShippingThreshold) || 0;

        this.i18n = {
          progress: this.dataset.offerProgressText || 'Add {count} more to unlock {reward}',
          complete: this.dataset.offerCompleteText || '{reward} unlocked',
          full: this.dataset.offerFullText || 'Your bundle is full',
          noMilestones: this.dataset.offerNoMilestonesText || 'Mix and match to build your bundle',
          priceTemplate: this.dataset.offerPriceTemplate || 'Save {savings}',
          priceZero: this.dataset.offerPriceZeroText || 'Add items to see your savings',
          rewardFallback: this.dataset.offerRewardFallback || 'your reward',
          emptySlot: this.dataset.emptySlotLabel || 'Empty slot, {count} of {total}',
        };

        // productId -> { productId, variantId, title, price, image, quantity, cardEl }
        this.selections = new Map();

        this.cards = Array.from(this.querySelectorAll('[data-bundle-product]'));
        this.milestoneEls = Array.from(this.querySelectorAll('[data-milestone]'));
        this.milestones = this.milestoneEls
          .map((el) => ({
            el,
            itemsRequired: Number(el.dataset.itemsRequired) || 0,
            discountPercent: Number(el.dataset.discountPercent) || 0,
            unitPrice: Number(el.dataset.unitPrice) || 0,
            rewardLabel: el.dataset.rewardLabel || '',
            badgeText: el.dataset.badgeText || '',
          }))
          .sort((a, b) => a.itemsRequired - b.itemsRequired);
        this.topRequired = this.milestones.length
          ? this.milestones[this.milestones.length - 1].itemsRequired
          : this.maxSlots;

        this.progressFill = this.querySelector('[data-bundle-progress-fill]');
        this.offerSubtitle = this.querySelector('[data-bundle-offer-subtitle]');
        this.offerPrice = this.querySelector('[data-bundle-offer-price]');
        this.shippingRow = this.querySelector('[data-bundle-shipping]');
        this.totalEl = this.querySelector('[data-bundle-total]');
        this.checkoutBtn = this.querySelector('[data-bundle-checkout]');
        this.errorEl = this.querySelector('[data-bundle-error]');
        this.sliderTrack = this.querySelector('[data-bundle-slider-track]');
        this.sliderPrev = this.querySelector('[data-bundle-slider-prev]');
        this.sliderNext = this.querySelector('[data-bundle-slider-next]');
        this.panel = this.querySelector('[data-bundle-panel]');
        this.toggleBtn = this.querySelector('[data-bundle-toggle]');
        this.viewBundleBtn = this.querySelector('[data-bundle-view-toggle]');

        this.cards.forEach((card) => {
          const addBtn = card.querySelector('[data-bundle-add]');
          const decreaseBtn = card.querySelector('[data-quantity-decrease]');
          const increaseBtn = card.querySelector('[data-quantity-increase]');
          if (addBtn) addBtn.addEventListener('click', () => this.bump(card, 1));
          if (increaseBtn) increaseBtn.addEventListener('click', () => this.bump(card, 1));
          if (decreaseBtn) decreaseBtn.addEventListener('click', () => this.bump(card, -1));
        });

        if (this.toggleBtn) this.toggleBtn.addEventListener('click', () => this.toggleExpanded());
        if (this.viewBundleBtn) this.viewBundleBtn.addEventListener('click', () => this.toggleExpanded());
        if (this.checkoutBtn) this.checkoutBtn.addEventListener('click', () => this.checkout());
        if (this.sliderPrev) this.sliderPrev.addEventListener('click', () => this.scrollSlider(-1));
        if (this.sliderNext) this.sliderNext.addEventListener('click', () => this.scrollSlider(1));
        if (this.sliderTrack) {
          this.sliderTrack.addEventListener('scroll', () => this.updateSliderArrows());
          window.addEventListener('resize', () => this.updateSliderArrows());
        }

        this.render();
      }

      toggleExpanded() {
        if (!this.panel) return;
        const expanded = this.panel.classList.toggle('is-expanded');
        if (this.toggleBtn) this.toggleBtn.setAttribute('aria-expanded', String(expanded));
        if (this.viewBundleBtn) this.viewBundleBtn.setAttribute('aria-expanded', String(expanded));
      }

      totalQty() {
        let total = 0;
        this.selections.forEach((item) => {
          total += item.quantity;
        });
        return total;
      }

      /**
       * Adds or removes units of a card's product. Every add and every
       * quantity step goes through here, clamped to whatever slots remain
       * across the whole bundle and, when the card reports finite inventory,
       * to what is actually in stock.
       */
      bump(card, delta) {
        const productId = card.dataset.productId;
        const existing = this.selections.get(productId);
        const currentQty = existing ? existing.quantity : 0;
        const remainingForOthers = this.maxSlots - (this.totalQty() - currentQty);
        let cap = remainingForOthers;
        if (card.dataset.inventoryQuantity !== undefined) {
          cap = Math.min(cap, Number(card.dataset.inventoryQuantity) || 0);
        }

        let nextQty = currentQty + delta;
        if (nextQty < 0) nextQty = 0;
        if (nextQty > cap) nextQty = cap;

        if (nextQty <= 0) {
          this.selections.delete(productId);
        } else {
          this.selections.set(productId, {
            productId,
            variantId: Number(card.dataset.variantId),
            title: card.dataset.title,
            price: Number(card.dataset.price) || 0,
            image: card.dataset.image,
            quantity: nextQty,
            cardEl: card,
          });
        }
        this.render();
      }

      removeUnit(productId) {
        const item = this.selections.get(productId);
        if (item) this.bump(item.cardEl, -1);
      }

      currentTier(count) {
        let unlocked = null;
        this.milestones.forEach((tier) => {
          if (count >= tier.itemsRequired) unlocked = tier;
        });
        return unlocked;
      }

      nextTier(count) {
        return this.milestones.find((tier) => tier.itemsRequired > count) || null;
      }

      usesUnitPrice(tier) {
        return this.tierMode === 'unit_price' && tier && tier.unitPrice > 0;
      }

      formatReward(tier) {
        if (!tier) return this.i18n.rewardFallback;
        let reward = '';
        if (this.usesUnitPrice(tier) && window.MasterTheme) {
          reward = `${window.MasterTheme.formatMoney(tier.unitPrice)}/${this.unitNoun}`;
        } else if (tier.discountPercent > 0) {
          reward = `${tier.discountPercent}% off`;
        }
        if (tier.rewardLabel) {
          reward = reward ? `${reward} + ${tier.rewardLabel}` : tier.rewardLabel;
        }
        return reward || tier.badgeText || this.i18n.rewardFallback;
      }

      scrollSlider(direction) {
        if (!this.sliderTrack) return;
        this.sliderTrack.scrollBy({ left: direction * this.sliderTrack.clientWidth * 0.9, behavior: 'smooth' });
      }

      updateSliderArrows() {
        if (!this.sliderTrack) return;
        const { scrollLeft, scrollWidth, clientWidth } = this.sliderTrack;
        const overflowing = scrollWidth > clientWidth + 1;
        if (this.sliderPrev) this.sliderPrev.hidden = !overflowing || scrollLeft <= 0;
        if (this.sliderNext) this.sliderNext.hidden = !overflowing || scrollLeft + clientWidth >= scrollWidth - 1;
      }

      render() {
        const count = this.totalQty();
        const full = count >= this.maxSlots;
        const tier = this.currentTier(count);
        const next = this.nextTier(count);

        this.milestoneEls.forEach((el, i) => {
          el.classList.toggle('is-active', count >= this.milestones[i].itemsRequired);
        });

        if (this.progressFill) {
          const percent = this.topRequired > 0 ? Math.min(100, (count / this.topRequired) * 100) : 0;
          this.progressFill.style.width = `${percent}%`;
        }

        // Add button and quantity stepper per card.
        this.cards.forEach((card) => {
          const addBtn = card.querySelector('[data-bundle-add]');
          const qtyWrap = card.querySelector('[data-quantity-wrapper]');
          const qtyValue = card.querySelector('[data-quantity-value]');
          const increaseBtn = card.querySelector('[data-quantity-increase]');
          const soldOut = addBtn ? addBtn.dataset.soldOut === 'true' : false;
          const selection = this.selections.get(card.dataset.productId);
          const selected = Boolean(selection);

          if (addBtn) {
            addBtn.hidden = selected;
            addBtn.disabled = soldOut || (full && !selected);
          }
          if (qtyWrap) qtyWrap.hidden = !selected;
          if (qtyValue) qtyValue.textContent = selected ? String(selection.quantity) : '0';
          if (increaseBtn) {
            const remaining = this.maxSlots - count;
            const inventoryLeft =
              card.dataset.inventoryQuantity !== undefined
                ? Number(card.dataset.inventoryQuantity) - (selection ? selection.quantity : 0)
                : Infinity;
            increaseBtn.disabled = remaining <= 0 || inventoryLeft <= 0;
          }
          card.classList.toggle('is-added', selected);
        });

        // Offer subtitle: no milestones set up, bundle full, progress toward
        // the next milestone, or the top milestone already unlocked with
        // room still left in the bundle. Each is its own setting.
        if (this.offerSubtitle) {
          if (!this.milestones.length) {
            this.offerSubtitle.textContent = this.i18n.noMilestones;
          } else if (full) {
            this.offerSubtitle.textContent = this.i18n.full;
          } else if (next) {
            this.offerSubtitle.textContent = this.i18n.progress
              .replace('{count}', String(next.itemsRequired - count))
              .replace('{reward}', this.formatReward(next));
          } else if (tier) {
            this.offerSubtitle.textContent = this.i18n.complete.replace('{reward}', this.formatReward(tier));
          } else {
            this.offerSubtitle.textContent = this.i18n.noMilestones;
          }
        }

        const rawSubtotal = Array.from(this.selections.values()).reduce(
          (sum, item) => sum + item.price * item.quantity,
          0
        );

        if (this.totalEl && window.MasterTheme) this.totalEl.textContent = window.MasterTheme.formatMoney(rawSubtotal);

        if (this.offerPrice && window.MasterTheme) {
          let projected = rawSubtotal;
          if (tier) {
            if (this.usesUnitPrice(tier)) {
              projected = tier.unitPrice * count;
            } else if (tier.discountPercent > 0) {
              projected = Math.round((rawSubtotal * (100 - tier.discountPercent)) / 100);
            }
          }
          const savings = rawSubtotal - projected;
          if (savings > 0) {
            this.offerPrice.textContent = this.i18n.priceTemplate.replace('{savings}', window.MasterTheme.formatMoney(savings));
          } else {
            this.offerPrice.textContent = this.i18n.priceZero;
          }
        }

        if (this.shippingRow) {
          this.shippingRow.classList.toggle(
            'is-met',
            this.showFreeShipping && rawSubtotal >= this.freeShippingThreshold
          );
        }

        // Selected products slider: one box per bundle slot, filled in the
        // order items were added. A product with quantity 2 fills two boxes,
        // each independently removable, which is what lets a shopper fill an
        // entire bundle from a collection with only one or two products.
        if (this.sliderTrack) {
          const units = [];
          this.selections.forEach((item) => {
            for (let i = 0; i < item.quantity; i += 1) units.push(item);
          });

          const rows = [];
          for (let i = 0; i < this.maxSlots; i += 1) {
            const item = units[i];
            if (item) {
              rows.push(
                `<li class="bundle-builder__slide bundle-builder__slide--filled">` +
                  `<img class="bundle-builder__slide-media" src="${escapeHtml(item.image || '')}" alt="" loading="lazy" width="44" height="44">` +
                  `<button type="button" class="bundle-builder__slide-remove" data-slide-remove="${escapeHtml(item.productId)}" aria-label="${escapeHtml(item.title)}">` +
                  `&times;` +
                  `</button>` +
                  `</li>`
              );
            } else {
              const label = this.i18n.emptySlot.replace('{count}', String(i + 1)).replace('{total}', String(this.maxSlots));
              rows.push(`<li class="bundle-builder__slide bundle-builder__slide--empty" aria-label="${escapeHtml(label)}">${i + 1}</li>`);
            }
          }
          this.sliderTrack.innerHTML = rows.join('');
          this.sliderTrack.querySelectorAll('[data-slide-remove]').forEach((btn) => {
            btn.addEventListener('click', () => this.removeUnit(btn.dataset.slideRemove));
          });
          this.updateSliderArrows();
        }

        if (this.checkoutBtn) this.checkoutBtn.disabled = count === 0;
      }

      async checkout() {
        if (!this.selections.size || !window.MasterTheme) return;
        if (this.errorEl) this.errorEl.hidden = true;

        const bundleId =
          window.crypto && window.crypto.randomUUID
            ? window.crypto.randomUUID()
            : `bundle-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

        const items = Array.from(this.selections.values()).map((item) => ({
          id: item.variantId,
          quantity: item.quantity,
          properties: { _bundle: bundleId },
        }));

        this.checkoutBtn.setAttribute('aria-busy', 'true');
        this.checkoutBtn.disabled = true;

        try {
          await window.MasterTheme.cart.add(items);
          this.selections.clear();
          this.render();
        } catch (error) {
          if (this.errorEl) {
            this.errorEl.textContent = error.message || 'Something went wrong adding your bundle. Please try again.';
            this.errorEl.hidden = false;
          }
        } finally {
          this.checkoutBtn.removeAttribute('aria-busy');
          this.checkoutBtn.disabled = this.selections.size === 0;
        }
      }
    }

    if (!customElements.get('bundle-builder')) {
      customElements.define('bundle-builder', BundleBuilder);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    class CountdownBanner extends HTMLElement {
      connectedCallback() {
        this.mode = this.dataset.mode || 'date';
        this.onExpire = this.dataset.onExpire || 'hide';
        this.mainEl = this.querySelector('[data-countdown-main]');
        this.altEl = this.querySelector('[data-countdown-alt]');

        // Daily deadlines roll over to the next day rather than truly
        // expiring, so the expiry behaviour only applies to fixed dates.
        if (this.mode !== 'date') return;

        this.target = new Date(this.dataset.date);
        if (Number.isNaN(this.target.getTime())) return;

        this.check();
        this.interval = setInterval(() => this.check(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      check() {
        if (this.target - new Date() > 0) return;
        clearInterval(this.interval);

        if (this.onExpire === 'message' && this.altEl) {
          if (this.mainEl) this.mainEl.hidden = true;
          this.altEl.hidden = false;
        } else {
          this.hidden = true;
        }
      }
    }

    if (!customElements.get('countdown-banner')) {
      customElements.define('countdown-banner', CountdownBanner);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  if (!customElements.get('address-fields')) {
    class AddressFields extends HTMLElement {
      connectedCallback() {
        this.countrySelect = this.querySelector('[data-address-country]');
        this.provinceSelect = this.querySelector('[data-address-province]');
        this.provinceWrapper = this.querySelector('[data-address-province-wrapper]');
        if (!this.countrySelect || !this.provinceSelect) return;

        const defaultCountry = this.dataset.defaultCountry || '';
        const defaultProvince = this.dataset.defaultProvince || '';

        if (defaultCountry) {
          this.countrySelect.value = defaultCountry;
        }

        this.countrySelect.addEventListener('change', () => this.updateProvinces(''));
        this.updateProvinces(defaultProvince);
      }

      updateProvinces(selected) {
        const option = this.countrySelect.options[this.countrySelect.selectedIndex];
        let provinces = [];
        if (option) {
          try {
            provinces = JSON.parse(option.getAttribute('data-provinces') || '[]');
          } catch (error) {
            provinces = [];
          }
        }

        this.provinceSelect.innerHTML = '';

        if (provinces.length) {
          provinces.forEach((pair) => {
            const optionEl = document.createElement('option');
            optionEl.value = pair[0];
            optionEl.textContent = pair[1];
            this.provinceSelect.appendChild(optionEl);
          });
          if (selected) this.provinceSelect.value = selected;
          if (this.provinceWrapper) this.provinceWrapper.hidden = false;
        } else if (this.provinceWrapper) {
          this.provinceWrapper.hidden = true;
        }
      }
    }

    customElements.define('address-fields', AddressFields);
  }

  if (!customElements.get('address-delete-form')) {
    class AddressDeleteForm extends HTMLElement {
      connectedCallback() {
        this.addEventListener('submit', (event) => {
          const button = event.submitter;
          const message = button && button.dataset.confirmMessage;
          if (message && !window.confirm(message)) {
            event.preventDefault();
          }
        });
      }
    }

    customElements.define('address-delete-form', AddressDeleteForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  if (!customElements.get('facet-filters')) {
    class FacetFilters extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.ajaxEnabled = this.dataset.ajaxEnabled === 'true';
        this.debounceTimer = null;

        if (!this.ajaxEnabled) return;

        this.classList.add('is-enhanced');
        this.bind();
      }

      bind() {
        this.addEventListener('submit', (event) => {
          const form = event.target.closest('[data-facets-form]');
          if (!form) return;
          event.preventDefault();
          this.applyForm(form, true);
        });

        this.addEventListener('change', (event) => {
          const field = event.target.closest('[data-facets-form] input, [data-facets-form] select');
          if (!field) return;
          const form = field.closest('form') || this.querySelector('[data-facets-form]');
          window.clearTimeout(this.debounceTimer);
          this.debounceTimer = window.setTimeout(() => this.applyForm(form, false), 150);
        });

        this.addEventListener('click', (event) => {
          const link = event.target.closest('[data-facets-remove], [data-facets-clear]');
          if (!link) return;
          event.preventDefault();
          this.applyUrl(link.href, true);
        });

        const toggle = this.querySelector('[data-facets-toggle-input]');
        if (toggle) {
          toggle.addEventListener('change', () => {
            if (toggle.checked) {
              this.lockScroll(true);
              window.requestAnimationFrame(() => {
                const panel = this.querySelector('[data-facets-panel]');
                const focusable = panel && panel.querySelector('a, button, input, select');
                if (focusable) focusable.focus();
              });
            } else {
              this.lockScroll(false);
              const trigger = this.querySelector('[data-facets-toggle-label]');
              if (trigger) trigger.focus();
            }
          });

          this.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && toggle.checked) {
              toggle.checked = false;
              toggle.dispatchEvent(new Event('change'));
            }
          });
        }
      }

      lockScroll(locked) {
        document.documentElement.classList.toggle('scroll-locked', locked);
      }

      applyForm(form, closeDrawer) {
        if (!form) return;
        const params = new URLSearchParams(new FormData(form));
        const url = `${form.getAttribute('action')}?${params.toString()}`;
        this.applyUrl(url, closeDrawer);
      }

      applyUrl(url, closeDrawer) {
        const fetchUrl = new URL(url, window.location.origin);
        fetchUrl.searchParams.set('section_id', this.sectionId);

        this.classList.add('is-loading');

        fetch(fetchUrl.toString())
          .then((response) => response.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const next = doc.querySelector('facet-filters');
            if (!next) return;

            const toggle = this.querySelector('[data-facets-toggle-input]');
            const wasOpen = toggle ? toggle.checked : false;

            this.innerHTML = next.innerHTML;
            this.classList.add('is-enhanced');
            this.bind();

            const newToggle = this.querySelector('[data-facets-toggle-input]');
            if (newToggle) newToggle.checked = closeDrawer ? false : wasOpen;
            if (closeDrawer) this.lockScroll(false);

            const cleanUrl = new URL(url, window.location.origin);
            cleanUrl.searchParams.delete('section_id');
            window.history.pushState({ facets: true }, '', cleanUrl.pathname + cleanUrl.search);
          })
          .catch(() => {
            window.location.href = url;
          })
          .finally(() => {
            this.classList.remove('is-loading');
          });
      }
    }

    customElements.define('facet-filters', FacetFilters);

    window.addEventListener('popstate', () => window.location.reload());
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  if (!customElements.get('login-panels')) {
    class LoginPanels extends HTMLElement {
      connectedCallback() {
        this.loginPanel = this.querySelector('[data-login-panel]');
        this.recoverPanel = this.querySelector('[data-recover-panel]');

        this.addEventListener('click', (event) => {
          const link = event.target.closest('[data-login-link]');
          if (!link) return;
          event.preventDefault();
          this.show(link.dataset.loginLink);
          window.history.replaceState(null, '', link.getAttribute('href'));
        });

        window.addEventListener('hashchange', () => this.sync());
        this.sync();
      }

      sync() {
        this.show(window.location.hash === '#recover' ? 'recover' : 'login');
      }

      show(name) {
        const showRecover = name === 'recover';
        if (this.recoverPanel) this.recoverPanel.hidden = !showRecover;
        if (this.loginPanel) this.loginPanel.hidden = showRecover;
      }
    }

    customElements.define('login-panels', LoginPanels);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-ugc-wall"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pdp-ugc-wall')) {
    class PdpUgcWall extends HTMLElement {
      connectedCallback() {
        this.triggers = Array.from(this.querySelectorAll('[data-wall-open]'));
        this.modal = this.querySelector('dialog');
        this.modalVideo = this.querySelector('[data-wall-modal-video]');
        this.modalHandle = this.querySelector('[data-wall-modal-handle]');
        this.modalCaption = this.querySelector('[data-wall-modal-caption]');
        this.closeBtn = this.querySelector('[data-wall-close]');
        this.rail = this.querySelector('[data-ugc-wall-rail]');

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (this.rail) {
          this.updateScrollEdges = this.updateScrollEdges.bind(this);
          this.rail.addEventListener('scroll', this.updateScrollEdges, { passive: true });
          window.addEventListener('resize', this.updateScrollEdges);
          this.updateScrollEdges();
        }

        this.triggers.forEach((trigger) => {
          trigger.addEventListener('click', () => this.openModal(trigger));

          if (!this.reducedMotion) {
            const video = trigger.querySelector('[data-wall-video]');
            if (video) {
              trigger.addEventListener('pointerenter', () => this.playPreview(video));
              trigger.addEventListener('pointerleave', () => this.pausePreview(video));
              trigger.addEventListener('focus', () => this.playPreview(video));
              trigger.addEventListener('blur', () => this.pausePreview(video));
            }
          }
        });

        if (this.closeBtn && this.modal) {
          this.closeBtn.addEventListener('click', () => this.modal.close());
        }

        if (this.modal) {
          this.modal.addEventListener('click', (event) => {
            if (event.target === this.modal) this.modal.close();
          });

          this.modal.addEventListener('close', () => {
            if (!this.modalVideo) return;
            this.modalVideo.pause();
            this.modalVideo.removeAttribute('src');
            this.modalVideo.load();
            if (this.opener) this.opener.focus({ preventScroll: true });
          });
        }

        if (!this.reducedMotion && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const video = entry.target.querySelector('[data-wall-video]');
                if (!video) return;
                if (entry.isIntersecting) {
                  this.playPreview(video);
                } else {
                  this.pausePreview(video);
                }
              });
            },
            { threshold: 0.6 }
          );
          this.triggers.forEach((trigger) => this.observer.observe(trigger));
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.updateScrollEdges) window.removeEventListener('resize', this.updateScrollEdges);
      }

      updateScrollEdges() {
        if (!this.rail) return;
        const maxScroll = this.rail.scrollWidth - this.rail.clientWidth;
        const hasMoreStart = this.rail.scrollLeft > 4;
        const hasMoreEnd = this.rail.scrollLeft < maxScroll - 4;

        this.rail.toggleAttribute('data-has-more-start', hasMoreStart);
        this.rail.toggleAttribute('data-has-more-end', hasMoreEnd);
      }

      playPreview(video) {
        if (this.reducedMotion) return;
        if (!video.src && video.dataset.src) video.src = video.dataset.src;
        const promise = video.play();
        if (promise && promise.catch) promise.catch(() => {});
      }

      pausePreview(video) {
        video.pause();
      }

      openModal(trigger) {
        if (!this.modal || !this.modalVideo) return;
        this.opener = trigger;
        this.modalVideo.src = trigger.dataset.src;
        this.modalVideo.muted = false;
        this.modalVideo.currentTime = 0;

        if (this.modalHandle) this.modalHandle.textContent = trigger.dataset.handle || '';
        if (this.modalCaption) this.modalCaption.textContent = trigger.dataset.caption || '';

        if (!this.modal.open) this.modal.showModal();

        const playPromise = this.modalVideo.play();
        if (playPromise && playPromise.catch) playPromise.catch(() => {});

        window.requestAnimationFrame(() => {
          if (this.closeBtn) this.closeBtn.focus();
        });
      }
    }

    customElements.define('pdp-ugc-wall', PdpUgcWall);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('stat-counter')) {
    class StatCounter extends HTMLElement {
      connectedCallback() {
        this.target = parseFloat(this.dataset.count);
        if (Number.isNaN(this.target)) return;

        this.decimals = (String(this.dataset.count).split('.')[1] || '').length;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.animated = false;

        if (this.reducedMotion || !('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && !this.animated) {
                this.animated = true;
                this.animate();
                this.observer.unobserve(this);
              }
            });
          },
          { threshold: 0.4 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      format(value) {
        return value.toFixed(this.decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }

      animate() {
        const duration = 1400;
        const start = performance.now();
        const to = this.target;

        const step = (now) => {
          const elapsed = now - start;
          const progress = Math.min(elapsed / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          this.textContent = this.format(to * eased);

          if (progress < 1) {
            window.requestAnimationFrame(step);
          } else {
            this.textContent = this.format(to);
          }
        };

        window.requestAnimationFrame(step);
      }
    }
    customElements.define('stat-counter', StatCounter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('carousel-autoplay')) {
    class CarouselAutoplay extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        if (!this.track) return;

        this.dots = Array.from(this.querySelectorAll('.testimonial-carousel__dot'));
        this.autoplay = this.dataset.autoplay === 'true';
        this.speed = parseInt(this.dataset.speed, 10) || 5000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.timer = null;
        this._scrollTimer = null;

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            this.goTo(parseInt(dot.dataset.carouselDot, 10));
          });
        });

        this.track.addEventListener('scroll', () => {
          window.clearTimeout(this._scrollTimer);
          this._scrollTimer = window.setTimeout(() => this.syncDots(), 100);
        });

        this.addEventListener('pointerenter', () => this.stop());
        this.addEventListener('pointerleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());

        if (this.autoplay && !this.reducedMotion) this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      start() {
        if (!this.autoplay || this.reducedMotion) return;
        this.stop();
        this.timer = window.setInterval(() => this.next(), this.speed);
      }

      stop() {
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }

      currentIndex() {
        const slideWidth = this.track.clientWidth || 1;
        return Math.round(this.track.scrollLeft / slideWidth);
      }

      next() {
        const count = this.track.children.length;
        if (!count) return;
        const nextIndex = (this.currentIndex() + 1) % count;
        this.goTo(nextIndex);
      }

      goTo(index) {
        const slide = this.track.children[index];
        if (!slide) return;
        this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }

      syncDots() {
        if (!this.dots.length) return;
        const index = this.currentIndex();
        this.dots.forEach((dot, i) => {
          const active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
        });
      }
    }
    customElements.define('carousel-autoplay', CarouselAutoplay);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-video-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ugc-gallery')) {
    class UgcGallery extends HTMLElement {
      connectedCallback() {
        this.triggers = Array.from(this.querySelectorAll('[data-ugc-open]'));
        this.modal = this.querySelector('dialog');
        this.modalVideo = this.querySelector('[data-ugc-modal-video]');
        this.modalHandle = this.querySelector('[data-ugc-modal-handle]');
        this.modalCaption = this.querySelector('[data-ugc-modal-caption]');
        this.modalShop = this.querySelector('[data-ugc-modal-shop]');
        this.closeBtn = this.querySelector('[data-ugc-close]');
        this.prevBtn = this.querySelector('[data-ugc-prev]');
        this.nextBtn = this.querySelector('[data-ugc-next]');
        this.rail = this.querySelector('[data-ugc-gallery-rail]');

        if (this.rail) {
          this.updateScrollEdges = this.updateScrollEdges.bind(this);
          this.rail.addEventListener('scroll', this.updateScrollEdges, { passive: true });
          window.addEventListener('resize', this.updateScrollEdges);
          this.updateScrollEdges();
        }

        if (!this.triggers.length || !this.modal || !this.modalVideo) return;

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplayInView = this.dataset.autoplayInView === 'true' && !this.reducedMotion;
        this.activeIndex = 0;
        this.opener = null;

        this.triggers.forEach((trigger, index) => {
          trigger.addEventListener('click', () => this.openModal(index));

          if (!this.reducedMotion) {
            const video = trigger.querySelector('[data-ugc-video]');
            if (video) {
              trigger.addEventListener('pointerenter', () => this.playPreview(video));
              trigger.addEventListener('pointerleave', () => this.pausePreview(video));
              trigger.addEventListener('focus', () => this.playPreview(video));
              trigger.addEventListener('blur', () => this.pausePreview(video));
            }
          }
        });

        if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.modal.close());
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));

        this.modal.addEventListener('click', (event) => {
          if (event.target === this.modal) this.modal.close();
        });

        this.modal.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.step(1);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.step(-1);
          }
        });

        this.modal.addEventListener('close', () => {
          this.modalVideo.pause();
          this.modalVideo.removeAttribute('src');
          this.modalVideo.load();
          if (this.opener) this.opener.focus({ preventScroll: true });
        });

        if (this.autoplayInView && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const video = entry.target.querySelector('[data-ugc-video]');
                if (!video) return;
                if (entry.isIntersecting) {
                  this.playPreview(video);
                } else {
                  this.pausePreview(video);
                }
              });
            },
            { threshold: 0.6 }
          );
          this.triggers.forEach((trigger) => this.observer.observe(trigger));
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.updateScrollEdges) window.removeEventListener('resize', this.updateScrollEdges);
      }

      updateScrollEdges() {
        if (!this.rail) return;
        const maxScroll = this.rail.scrollWidth - this.rail.clientWidth;
        const hasMoreStart = this.rail.scrollLeft > 4;
        const hasMoreEnd = this.rail.scrollLeft < maxScroll - 4;

        this.rail.toggleAttribute('data-has-more-start', hasMoreStart);
        this.rail.toggleAttribute('data-has-more-end', hasMoreEnd);
      }

      playPreview(video) {
        if (this.reducedMotion) return;
        if (!video.src && video.dataset.src) video.src = video.dataset.src;
        const promise = video.play();
        if (promise && promise.catch) promise.catch(() => {});
      }

      pausePreview(video) {
        video.pause();
      }

      openModal(index) {
        const count = this.triggers.length;
        this.activeIndex = ((index % count) + count) % count;
        const trigger = this.triggers[this.activeIndex];
        const fullSrc = trigger.dataset.fullSrc || trigger.dataset.src;

        this.opener = trigger;
        this.modalVideo.src = fullSrc;
        this.modalVideo.muted = false;
        this.modalVideo.currentTime = 0;

        if (this.modalHandle) this.modalHandle.textContent = trigger.dataset.handle || '';
        if (this.modalCaption) this.modalCaption.textContent = trigger.dataset.caption || '';

        if (this.modalShop) {
          if (trigger.dataset.shopUrl) {
            this.modalShop.href = trigger.dataset.shopUrl;
            this.modalShop.textContent = 'Shop ' + (trigger.dataset.shopLabel || 'this product');
            this.modalShop.classList.remove('hide');
          } else {
            this.modalShop.removeAttribute('href');
            this.modalShop.classList.add('hide');
          }
        }

        if (!this.modal.open) this.modal.showModal();

        const playPromise = this.modalVideo.play();
        if (playPromise && playPromise.catch) playPromise.catch(() => {});

        window.requestAnimationFrame(() => {
          if (this.closeBtn) this.closeBtn.focus();
        });
      }

      step(direction) {
        this.openModal(this.activeIndex + direction);
      }
    }
    customElements.define('ugc-gallery', UgcGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["upsell-row"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';

    class UpsellAddAll extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button) return;

        this.button.addEventListener('click', async () => {
          const row = this.closest('.upsell-row');
          if (!row || !window.MasterTheme) return;

          const items = Array.from(row.querySelectorAll('[data-upsell-item]'))
            .map((el) => Number(el.dataset.variantId))
            .filter(Boolean)
            .map((id) => ({ id, quantity: 1 }));

          if (!items.length) return;

          this.button.setAttribute('aria-busy', 'true');
          try {
            await window.MasterTheme.cart.add(items);
          } catch (error) {
            /* MasterTheme.cart already surfaces a toast/error via the cart:error event. */
          } finally {
            this.button.removeAttribute('aria-busy');
          }
        });
      }
    }

    if (!customElements.get('upsell-add-all')) {
      customElements.define('upsell-add-all', UpsellAddAll);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
